﻿// Open a URL in a new tab
const openInNewTab = (url) => {
    window.open(url, '_blank');
};

// Open a URL in the same tab
const openInSameTab = (url) => {
    window.location.href = url;
};

// Function to redirect based on target ('_blank' for a new tab, '_self' for the same tab - by default)
const redirectTo = (url, target = '_self') => {
    if (target === '_blank') {
        openInNewTab(url);
    } else {
        openInSameTab(url);
    }
};

export { redirectTo };